// JS file for ProductSearch
